import { useEffect, useState } from 'react';
import 'react-tooltip/dist/react-tooltip.css';

export const AddressCardSm = ({ addressData }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  const updateMedia = () => {
    setIsMobile(window.innerWidth <= 575);
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  return (
    <div className="address-card w-100 d-flex flex-column align-items-left m-3 ">
      {isMobile ? (
        <>
          <span>{addressData?.first_name + ' ' + addressData?.last_name}</span>
          <span>{addressData.street_1}</span>
          {addressData?.street_2?.length > 0 && (
            <span>{addressData?.street_2}</span>
          )}
          <span>{`${addressData.city +
            ',' +
            ' ' +
            (addressData.state.value || addressData.state) +
            ' ' +
            addressData.zip}`}</span>
        </>
      ) : (
        <>
          <span>{addressData?.first_name + ' ' + addressData?.last_name}</span>
          <span>
            {/* <b>Address Line 1:</b>  */}
            {addressData.street_1}
          </span>
          {addressData?.street_2?.length > 0 && (
            <span>
              {/* <b>Address Line 2:</b>  */}
              {addressData?.street_2}
            </span>
          )}
          <span>{`${addressData.city +
            ',' +
            ' ' +
            (addressData.state.value || addressData.state) +
            ' ' +
            addressData.zip}`}</span>

          {/* <div className={'card-divider align-self-center mt-1'}></div> */}
        </>
      )}
    </div>
  );
};
